// import React from 'react'
// import UploadManager from '../../components/ui/FileManager'

// const Test = () => {
//   return (
//     <div>
//         <UploadManager/>

//     </div>
//   )
// }

// export default Test

import React, { useState, useCallback } from 'react';
import accountApi from '../../api/accountApi';
import SearchBar from '../../components/SearchBar';
import { useSelector } from 'react-redux';
import AddWorkflowAll from '../../components/workflow/AddWorkflowAll';

const Test = () => {
    const token = useSelector((state) => state.auth.access_token);
    const [accounts, setAccounts] = useState([]);
    const [loading, setLoading] = useState(false);

    // useCallback prevents the function from being recreated every render
    const handleApiSearch = useCallback(async (query) => {
        // Only hit API if query is 3+ characters
        if (!query || query.length < 3) {
            setAccounts([]);
            return;
        }

        try {
            setLoading(true);
            const res = await accountApi.searchAccounts(query, token);
            const data = res.data || [];
            console.log("API Data:", data);
            setAccounts(data);
        } catch (e) {
            console.error("Search error:", e);
        } finally {
            setLoading(false);
        }
    }, [token]); // Only recreate if token changes

    return (
        // <div className="p-10">
        //     <div className="max-w-md">
        //         <SearchBar
        //             onQueryChange={handleApiSearch}
        //             placeholder="Search accounts via API..."
        //         />
                
        //         {loading && <p className="text-sm text-blue-500 mt-2">Fetching results...</p>}
                
        //         <div className="mt-5">
        //             <h4 className="font-bold border-b pb-2">Results (Check Console)</h4>
        //             <ul className="mt-2 space-y-2">
        //                 {accounts.map(acc => (
        //                     <li key={acc.id} className="p-2 bg-gray-50 rounded border">
        //                         {acc.accountName} - <span className="text-gray-500">{acc.industry}</span>
        //                     </li>
        //                 ))}
        //             </ul>
        //         </div>
        //     </div>
        // </div>
        <AddWorkflowAll/>
    );
};

export default Test;